/** Stable id for the node directly above the sticky recommended category row (desktop + mobile). */
export const NH_RECOMMENDED_CATEGORY_STRIP_SENTINEL_ID = 'nh-recommended-category-strip-sentinel';

const OVERLAP_TOLERANCE_PX = 0.5;

/**
 * Height from the top of the viewport through which the sticky desktop category bar and
 * the sticky `DesktopNavbar` stack (see `--nh-sticky-header-h` + measured nav height).
 */
export function getNhRecommendedBrowseDesktopNavOverlapReservePx(): number {
  if (typeof document === 'undefined') return 48;
  const raw = getComputedStyle(document.documentElement).getPropertyValue('--nh-sticky-header-h').trim();
  const headerOff = Number.parseFloat(raw) || 0;
  const nav = document.querySelector<HTMLElement>('.hdr-desktop nav.group');
  let navH = 48;
  if (nav) {
    const h = nav.getBoundingClientRect().height;
    if (h > 0) navH = h;
  }
  return headerOff + navH;
}

/**
 * Same rule as IntersectionObserver(viewport, threshold 0): strip is stuck when the sentinel has
 * fully passed above the viewport (not merely below the fold).
 */
export function isRecommendedCategoryFilterStripStuck(sentinelEl: HTMLElement): boolean {
  const r = sentinelEl.getBoundingClientRect();
  const intersectsViewport =
    r.bottom > 0 &&
    r.top < window.innerHeight &&
    r.right > 0 &&
    r.left < window.innerWidth;
  return !intersectsViewport && r.top < 0;
}

/**
 * Desktop: hide the sticky navbar as soon as the category row reaches the navbar band — not only
 * after the sentinel has fully cleared the viewport (which left the circles under the bar).
 */
export function isRecommendedCategoryFilterStripShouldHideDesktopNav(sentinelEl: HTMLElement): boolean {
  if (isRecommendedCategoryFilterStripStuck(sentinelEl)) return true;
  const reserve = getNhRecommendedBrowseDesktopNavOverlapReservePx();
  return sentinelEl.getBoundingClientRect().bottom <= reserve + OVERLAP_TOLERANCE_PX;
}

export function readRecommendedCategoryFilterStripStuckFromDocument(): boolean {
  if (typeof document === 'undefined') return false;
  const el = document.getElementById(NH_RECOMMENDED_CATEGORY_STRIP_SENTINEL_ID);
  if (!el) return false;
  return isRecommendedCategoryFilterStripShouldHideDesktopNav(el);
}
